import React, { useState } from 'react';
import { usePrefs, useLabels, useFlags } from 'ws-scripts/modules/common';
import { useSelector } from 'react-redux';
import { setClassNames } from 'ddc-classnames-js'
import AllReviewsModal from './AllReviewsModal';

const Footer = () => {
	const [isOpenModal, setOpenModal] = useState(false);
	const kbbCustomerRatings = useSelector((state) => state.ratings);
	const reviews = useSelector((state) => state.reviews);
	const { useHorizontalStyle, useInverseTextColor } = usePrefs();
	const labels = useLabels();
	const flags = useFlags();
	const isUseResearchableAPI = flags['ws-kbb-reviews-use-researchable-api'];
	const {
		numberOfReviews: totalReviews,
		generationStartYear: startYear,
		generationEndYear: endYear
	} = kbbCustomerRatings;

	const determineStartEndYear = (y1, y2) => {
		const currentYear = new Date().getFullYear();
		const start = String(y1 === 'current' ? currentYear : y1);
		const end = String(y2 === 'current' ? currentYear : y2);
		const separator = !start || !end ? '' : '–';
		return start === end ? start : `${start}${separator}${end}`;
	};
	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	const enableHorizontalLayout = useHorizontalStyle === 'true';
	const textMutedColor =
		useInverseTextColor === 'true' ? 'text-muted-inverse' : 'text-muted';

	let textLinkColor = '';
	if (useInverseTextColor === 'true') {
		textLinkColor = enableHorizontalLayout
			? 'text-muted-inverse'
			: 'text-link-inverse';
	} else if (enableHorizontalLayout) {
		textLinkColor = 'text-muted';
	}

	const footerClasses = [
		'kbb-footer',
		'mt-3',
		enableHorizontalLayout ? 'ddc-font-size-xsmall' : ''
	];

	const privacyClasses = [
		'kbb-privacy-link',
		textLinkColor,
		enableHorizontalLayout ? 'ml-3' : '',
		enableHorizontalLayout ? 'text-decoration-underline' : ''
	];
	const iconClasses = [
		'ddc-icon',
		'ddc-icon-launch',
		'ddc-font-size-large'
	];

	return (
		<div className={setClassNames(footerClasses)}>
			{isUseResearchableAPI && (
				<div 
					className="d-inline-flex align-items-center mr-3"
					onClick={toggleOpenModal}
					onKeyPress={(e) => e.key === 'Enter' && toggleOpenModal()}
					role="button"
					tabIndex={0}
				>
					<span className="text-decoration-underline font-weight-normal mr-3">
						{labels.get('ALL_REVIEWS_ON_KBB.COM')}
					</span>
					<span className="mt-2">
						<i className={setClassNames(iconClasses)}/>
					</span>
				</div>
			)}
			{totalReviews && startYear && endYear && (
				<span>
					<span className={`kbb-footer-text ${textMutedColor}`}>
						Based on {totalReviews} consumer ratings for{' '}
						{determineStartEndYear(startYear, endYear)} models.
					</span>
					{!enableHorizontalLayout && (
						<span
							className={`${textMutedColor} separator`}
							aria-hidden="true"
						>
							&nbsp;|&nbsp;
						</span>
					)}
				</span>
			)}

			<a
				className={setClassNames(privacyClasses)}
				target="_blank"
				rel="noopener noreferrer"
				href="https://www.kbb.com/company/privacy-policy/"
			>
				Privacy{' '}
			</a>

			{isOpenModal && isUseResearchableAPI && (
				<AllReviewsModal
					reviews={reviews.items}
					onClose={toggleOpenModal}
					isOpen={isOpenModal}
				/>
			)}
		</div>
	);
};

export default Footer;
